var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-link',{class:_vm.$style.hiddenIcon,attrs:{"icon":"fal fa-times"},on:{"click":_vm.openDebugPopup}})}
var staticRenderFns = []

export { render, staticRenderFns }